<template>
  <div class="consultation">
    <div class="contentBody" v-show="!showIsReccept && !showIsCall">
      <div class="contianer" v-if="hasMask">
        <div class="waiting-cover">
          <div class="waiting">
            {{ userInfo.inquiryType == 2 ? '等待医生回复' : '正在为您寻找医生' }}
            <img src="../../assets/gif/loadingycf.gif" alt="" srcset="">
          </div>
        </div>
      </div>
      <div class="nav-head" v-if="!hasMask">
        <div class="back" v-if="!delGoBack">
          <img src="../../assets/image/nav_back.png" @click="goBack">
        </div>
        <div class="nav-title">{{ navTitle }}</div>
      </div>
      <div class="mainContent" ref="container" v-if="!hasMask">
        <template v-if="userInfo.clientID === isRuiZe">
          <div class="nav-tips">医生问诊过程中，请不要离开聊天页面</div>
          <div class="fix-bottom"></div>
        </template>
        <div class="more-message" v-if="!isCompleted" @click="getMessageList">更多消息</div>
        <div class="no-more-message" v-else>暂无更多消息</div>
        <MessageItem :options="item" v-for="(item) in messageList" :key="item.ID"></MessageItem>
        <div class="seat"></div>
      </div>
      <div class="send" v-if="step === 1">
        <div class="send-button-area">
          <div class="send-button" @click="isSend" :class="!hasSend ? 'blue-btn' : 'grey-btn'">发起视频申请</div>
        </div>
      </div>
      <div class="end-inq" v-if="step >= 2">
        <div class="close-inquiry">
          <h3>问诊已关闭</h3>
          <span>
            如仍需帮助，请再次发起问诊
          </span>
        </div>
        <button class="end-button" @click="checkThird" type="primary">
          结束问诊
        </button>
      </div>
    </div>

    <div class="video_main" v-show="showIsCall" style="background-color: #1B232F">
      <div class="yfw-header-hang">
        <!--          <img class="imageView" src="../../assets/image/avatarDoctor.png" alt="">-->
        <!--        <span class="labelText">呼叫医生 {{orderDetail.doctorName}}</span>-->
      </div>
      <div class="video-dialog_footer yfw-footer-hang">
        <div class="hang-wrap" @click="showIsCall = false">
          <span class="waitText">等待医生 {{ orderDetail.doctorName }} 接听中...</span>
          <img class="imageView" src="../../assets/image/icon_endCall@2x.png" alt="">
          <span class="labelText">挂断</span>
        </div>
      </div>
    </div>
    <div class="video-component" v-show="showVideo">
      <TUICallKit :allowedMinimized="false" :allowedFullScreen="false" />
    </div>
  </div>
</template>

<script>
import { FeatureButton, TUICallKit, TUICallKitServer } from '@tencentcloud/call-uikit-vue'
import { showNotify, showToast, showDialog } from 'vant';
import { mapMutations, mapGetters } from 'vuex';
import { getUrlParams } from '../../utils/const'
import MessageItem from '../../components/messageItem/BaseMessageItem.vue';
import TencentCloudChat from '@tencentcloud/chat';
import { finishOrder, receiveCall } from '@/utils/EventForAndroid'
const DEL_GO_BACK = ['chaoneng']
export default {
  name: 'trtcCalling',
  components: {
    MessageItem,
    TUICallKit
  },

  data() {
    return {
      showVideo: false,
      // inputValue: '医生即将发起视频，请不要退出当前页面，以免错过接听',
      inputVideo: '医生正在视频中，请不要离开当前页面，医生即将回拨或稍后重试',
      logined: false,
      messageList: [],
      nextReqMessageID: 0,
      isCompleted: false,
      timer: null,
      showIsReccept: false,
      showIsCall: false,
      hasSend: false,
      countTime: 60,
      getTime: '', // 通话时长
      callingTimer: null,
      delGoBack: false,
      isRuiZe: process.env.VUE_APP_RUIZE_CLIENT_ID// 是否是睿择
    }
  },
  computed: {
    ...mapGetters(['step', 'orderDetail', 'userInfo', 'hasMask', 'imInfo', 'urlParams', 'deviceType', 'endInquiry', 'timDuration']),
    navTitle() {
      if (this.orderDetail.sectionName && this.orderDetail.doctorName) {
        return this.orderDetail.sectionName + '  ' + this.orderDetail.doctorName
      } else {
        return '医生问诊'
      }
    }
  },
  mounted() {
    const deviceType = this.deviceType || getUrlParams()['deviceType']
    const clientName = getUrlParams()['clientName']
    this.delGoBack = DEL_GO_BACK.includes(clientName)
    window.switchCamera = this.switchCamera
    window.addEventListener('popstate', () => {
      if (deviceType === 'wechat') {
        wx.miniProgram.navigateBack({
          delta: history.length
        });
      } else if (deviceType === 'uniapp') {
        window.postMessage({
          data: {
            action: 'popstate'
          }
        }, '*')
        uni.postMessage({
          data: {
            action: 'popstate'
          }
        })
      } else {
        history.go(-(history.length - 2));
      }
    });
  },
  async created() {
    // this.getImInfo();
    await this.getUrlParams()
    await this.getOrderStatusInfo()
    this.timListener()
    this.trtcLogin()
    this.initTrtcEvent()
    this.hidFeatureButton()
  },
  methods: {
    initTrtcEvent() {
      TUICallKitServer._tuiCallEngine.on('onCallReceived', (event) => {
        this.showVideo = true
        this.showIsCall = false
        receiveCall()
      })
      TUICallKitServer._tuiCallEngine.on('onCallEnd', (event) => {
        this.showVideo = false
      })
    },

    // 为了设配机器人设备 这里隐藏摄像头按钮，不然机器人设备 通话界面按钮有遮挡重叠
    hidFeatureButton() {
      const clientName = getUrlParams()['clientName']
      if (DEL_GO_BACK.includes(clientName)) {
        TUICallKitServer.hideFeatureButton(FeatureButton.Camera);
        TUICallKitServer.hideFeatureButton(FeatureButton.SwitchCamera);
      }

      // TUICallKitServer.hideFeatureButton(FeatureButton.Camera);
    },

    switchCamera() {
      TUICallKitServer.switchCamera()
        .then((res) => {
          console.log('摄像头 切换成功111' + res);
        })
        .catch((error) => {
          console.log('摄像头 切换失败' + error);
        });
    },

    checkThird() {
      const { bizID, inquiryOrderID } = this.orderDetail;
      const deviceType = this.deviceType || getUrlParams()['deviceType']
      const params = {
        bizID: bizID,
        inquiryID: inquiryOrderID,
        deviceType: deviceType,
        requireType: 'finishInquiry'
      }
      this.$_http
        .post(this.$_API.H5_INQUIRY_POST_CHECKTHIRD, params)
        .then(res => {
          const { url } = res.data;
          if (url === '') {
            showToast('结束成功')
            // this.goBack()
            this.$router.back()
          } else {
            if (deviceType === 'wechat') {
              wx.miniProgram.navigateTo({
                url,
                success: function (res) {
                  console.log('navigateTo成功', res)
                },
                fail: function (res) {
                  console.log('navigateTo失败', res)
                }
              });
              wx.miniProgram.redirectTo({
                url,
                success: function (r) {
                  console.log('redirectTo成功', r)
                },
                fail: function (r) {
                  console.log('redirectTo失败', r)
                }
              });
              wx.miniProgram.switchTab({
                url,
                success: function (r) {
                  console.log('switchTab 成功', r)
                },
                fail: function (r) {
                  console.log('switchTab 失败', r)
                }
              });
              wx.miniProgram.reLaunch({
                url,
                success: function (r) {
                  console.log('reLaunch 成功', r)
                },
                fail: function (r) {
                  console.log('reLaunch 失败', r)
                }
              });
            } else if (deviceType === 'uniapp') {
              window.postMessage({
                data: {
                  action: 'finishOrder',
                  url
                }
              }, '*')
              uni.postMessage({
                data: {
                  action: 'finishOrder',
                  url
                }
              })
            } else {
              window.location.href = `${url}`;
            }
          }
        });
      finishOrder()
    },
    async getOrderStatusInfo() {
      console.log(this.urlParams.orderID)
      if (!this.urlParams.orderID) {
        return false
      }
      let params = {
        orderID: this.urlParams.orderID
      }
      await this.$_http.get(this.$_API.H5_INQUIRY_CENTER_GET_ORDER_STATUS, { params }).then(res => {
        if (res.success) {
          clearInterval(this.statusTimer);
          this['user/updateOrderDetail']({ ...this.orderDetail, ...res.data, doctorID: res.data.doctorIMID, userSig: res.data.patientUserSig })
          if (!this.userInfo.patientInfo) {
            this['user/updateUserInfo']({ ...this.userInfo, patientInfo: { patientName: res.data.patientName } })
          }
          this.toPage()
        }
      })
    },
    toPage() {
      // 问诊状态(0:无 / 1:待派单 / 2:已派单待接诊 / 3:已接诊 / 4:接诊完成 / 5:医生取消 / 6:患者取消 / 7:超时 / ）
      if (this.orderDetail.inquiryStatus === 1) {
        this.$router.replace({
          path: '/waiting',
          query: {
            ...this.urlParams
          }
        })
      } else if (this.orderDetail.inquiryStatus > 1 && this.orderDetail.inquiryStatus < 5) {
        if (this.orderDetail.inquiryStatus === 4) {
          this['global/updateStep'](3)
        } else {
          this['global/updateStep'](1)
        }
        if (this.orderDetail.inquiryType === 1) {
          this.$router.replace({
            path: '/consultation',
            query: {
              ...this.urlParams
            }
          })
        } else if (this.orderDetail.inquiryType === 2) {
          // this.$router.replace({
          //   path: '/trtcCalling',
          //   query: {
          //     ...this.urlParams
          //   }
          // })
        } else {
          this.$router.replace({
            path: '/videoPage',
            query: {
              ...this.urlParams
            }
          })
        }
      } else if (this.orderDetail.inquiryStatus >= 5) {
        showDialog({
          message: '问诊已取消，请退出后重新发起问诊',
          confirmButtonText: '知道了',
          confirmButtonColor: '#438BEF',
          closeOnClickOverlay: true
        }).then(() => {
          this.$router.replace({
            path: '/',
            query: {
              ...this.urlParams
            }
          })
        });
      }
    },
    getCountTime() {
      this.timer = setInterval(() => {
        this.countTime--
        if (this.countTime < 0) {
          this.hasSend = false;
          this.countTime = 60;
          clearInterval(this.timer)
        }
      }, 1000)
    },
    async trtcLogin() {
      await TUICallKitServer.init({
        tim: this.tim,
        SDKAppID: parseInt(process.env.VUE_APP_SDK_APP_ID),
        userID: this.imInfo.patientImID || this.orderDetail.patientIMID,
        userSig: this.imInfo.userSig || this.orderDetail.userSig
      });
      if (this.urlParams.type) {
        setTimeout(() => {
          this.isSend();
        }, 1000)
      }
    },
    // 快速问诊-获取IM登录信息
    getImInfo() {
      if (!this.orderDetail.bizID) {
        return false
      }
      let params = {
        patientInfoID: '',
        bizID: this.orderDetail.bizID,
        clientID: this.orderDetail.clientID,
        clientAppID: this.orderDetail.clientAppID,
        timestamp: this.orderDetail.timestamp,
        sign: this.orderDetail.sign
      }
      this.$_http.get(this.$_API.H5_INQUIRY_CENTER_GET_IM_INFO, { params }).then(res => {
        if (res.success && res.data.orderStatus < 1) {

        }
      })
    },
    // getMessage
    getMessageList() {
      if (this.isCompleted) {
        return false
      }
      let params = { conversationID: 'C2C' + this.orderDetail.doctorID, count: 15 }
      let _that = this
      if (this.nextReqMessageID !== 0) {
        params.nextReqMessageID = this.nextReqMessageID
      }
      // 打开某个会话时，第一次拉取消息列表
      let promise = this.tim.getMessageList(params);
      promise.then(function (imResponse) {
        console.log(imResponse)
        const messageList = imResponse.data.messageList; // 消息列表。
        const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
        const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
        for (let i = messageList.length - 1; i >= 0; i--) {
          if (typeof messageList[i].payload.data === 'string' && messageList[i].type === 'TIMCustomElem') {
            let data = JSON.parse(messageList[i].payload.data)
            console.log(data)
            if (data.customType === 'card') {
              if (data.childType === 'rpImg') {
                let FileMessage = {
                  progress: 100,
                  from: _that.orderDetail.orderPatientID + '1',
                  type: 'TIMImageElem',
                  src: data.data.rpImgUrl,
                  payload: {
                    data: 'imageMessage'
                  }
                }
                _that['global/updateStep'](2)
                messageList.splice(i, 1, FileMessage)
              }
            } else if (data.customType === 'sys') {
              if (data.childType === 'doctor_reject') {
                this['global/updateStep'](2)
              } else if (data.childType === 'doctor_pass') {
                this['global/updateStep'](3)
              }
            }
            if (_that.step === 3 || _that.step === 2) {
              break;
            }
          }
        }
        if (_that.nextReqMessageID === 0) {
          _that.messageList.unshift(...messageList.slice(0, messageList.length - _that.messageList.length))
        } else {
          _that.$nextTick(function () {
            _that.messageList.unshift(...messageList)
          })
        }
        _that.nextReqMessageID = nextReqMessageID
        _that.isCompleted = isCompleted
        _that.handleScrollBottom()
      });
    },
    // 添加监听消息
    timListener() {
      // 收到新消息
      this.tim.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
      this.tim.on(TencentCloudChat.EVENT.SDK_READY, this.sdkReady);
    },
    // sdk监听初始化成功，tim ready状态
    sdkReady(event) {
      this.getMessageList()
      this.logined = true
    },
    // 通话时长格式化
    getTalkTime() {
      // let h = parseInt(getTime / 3600);
      // if (h < 10) {
      //   h = '0' + h
      // }
      const getTime = parseInt(this.timDuration.duration / 1000)
      console.log(getTime)
      let m = parseInt((getTime % 3600) / 60);
      if (m < 10) {
        m = '0' + m
      }
      let s = ((getTime % 3600) % 60);
      if (s < 10) {
        s = '0' + s
      }
      this.talkTime = `视频时长 ${m}:${s}`
      return this.talkTime
    },
    // 监听收到消息的事件
    onReceiveMessage(event) {
      console.log('=================')
      console.log('event', event)
      // const endTxt = '本次会话已关闭~如有非医学类问题咨询，请联系客服哦~'
      if (event.data[0].payload.description === 'inquiryFinish' && event.data[0].type === 'TIMCustomElem') {
        this['global/updateStep'](2)
      }
      if (typeof event.data[0].payload.data === 'string' && event.data[0].type === 'TIMCustomElem') {
        let data = JSON.parse(event.data[0].payload.data)
        console.log('消息详情==', data)
        if (data.actionType === 1) { // 通话时长
          let jsonData = JSON.parse(data.data)
          console.log(jsonData)
          if (jsonData.data.cmd === 'hangup' && this.timDuration.videoStart !== '') {
            // this.getTime = jsonData.call_end
            this.inputValue = this.getTalkTime()
            this.sendMsg();
          }
        }
        if (data.customType === 'sys') {
          if (data.childType === 'doctor_reject') {
            this['global/updateStep'](2)
          } else if (data.childType === 'doctor_pass') {
            this['global/updateStep'](3)
          } else if (data.childType === 'sendDoctorInfo') {
            this['global/updateDoctorInfo'](data.data)
          } else if (data.childType === 'rp_order_start') {
            this['global/updateStep'](1)
            this['user/updateOrderDetail']({ ...this.orderDetail, doctorID: JSON.parse(event.data[0].payload.data).data.doctorID })
            this['global/updateMask'](false)
          }
          return false
        } else if (data.customType === 'card') {
          if (data.childType === 'rpImg') {
            let FileMessage = {
              progress: 100,
              from: this.orderDetail.orderPatientID + '1',
              type: 'TIMImageElem',
              src: data.data.rpImgUrl,
              payload: {
                data: 'imageMessage'
              }
            }
            this['global/updateStep'](2)
            this.messageList.push(FileMessage)
            this.handleScrollBottom()
            return false
          }
        }
      }
      this.messageList.push(event.data[0])
      this.handleScrollBottom()
    },
    sendVideo() {
      let _that = this
      if (!this.logined) {
        showNotify({
          type: 'warning',
          message: '请先登录',
          duration: 1000
        });
        return false;
      }
      const mesData = {
        customType: 'hint',
        dataType: 'hint',
        data: {
          text: _that.inputVideo
        }
      }
      console.log(JSON.stringify(mesData))
      let message = this.tim.createCustomMessage({
        to: this.orderDetail.doctorID,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: {
          data: JSON.stringify(mesData),
          description: '申请拨打视频',
          extension: 'ycf'
        }
      });
      let promise = this.tim.sendMessage(message);
      promise.then(function (imResponse) {
        // 发送成功
        _that.messageList.push(imResponse.data.message)
        _that.hasSend = true;
        _that.getCountTime();
        _that.handleScrollBottom()
      }).catch(function (imError) {
        // 发送失败
        console.log('sendMessage error:', imError);
        showNotify({
          type: 'warning',
          message: '发送失败',
          duration: 1000
        });
        return false;
      });
    },
    // 发送消息
    isSend() {
      this.sendVideo()
      this.showIsCall = true
      this.callingTimer = setTimeout(() => {
        if (this.showIsCall) {
          this.showIsCall = false
          showToast('医生正在忙碌，请重新发起问诊，或稍后再试');
        }
      }, 30000);
    },
    sendMsg() {
      let _that = this
      if (!this.logined) {
        showNotify({
          type: 'warning',
          message: '请先登录',
          duration: 1000
        });
        return false;
      }
      let message = this.tim.createTextMessage({
        to: this.orderDetail.doctorID,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: {
          text: this.inputValue
        }
      });
      let promise = this.tim.sendMessage(message);
      promise.then(function (imResponse) {
        // 发送成功
        _that.messageList.push({
          from: _that.orderDetail.patientIMID,
          to: _that.orderDetail.doctorIMID,
          type: 'TIMTextElem',
          payload: {
            text: _that.inputValue
          }
        })
        _that.inputValue = ''
        _that.handleScrollBottom()
      }).catch(function (imError) {
        // 发送失败
        console.log('sendMessage error:', imError);
        showNotify({
          type: 'warning',
          message: '发送失败',
          duration: 1000
        });
        return false;
      });
    },
    send() {
      let _that = this
      if (!this.logined) {
        showNotify({
          type: 'warning',
          message: '请先登录',
          duration: 1000
        });
        return false;
      }
      const mesData = {
        customType: 'hint',
        dataType: 'hint',
        data: {
          text: _that.inputValue
        }
      }
      console.log(JSON.stringify(mesData))
      let message = this.tim.createCustomMessage({
        to: this.orderDetail.doctorID,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: {
          data: JSON.stringify(mesData),
          description: '申请拨打视频',
          extension: 'ycf'
        }
      });
      let promise = this.tim.sendMessage(message);
      promise.then(function (imResponse) {
        // 发送成功
        _that.messageList.push(imResponse.data.message)
        _that.hasSend = true;
        _that.getCountTime();
        _that.handleScrollBottom()
      }).catch(function (imError) {
        // 发送失败
        console.log('sendMessage error:', imError);
        showNotify({
          type: 'warning',
          message: '发送失败',
          duration: 1000
        });
        return false;
      });
    },
    // 发送消息、获取消息向下滚动
    handleScrollBottom() {
      setTimeout(() => {
        let dom = this.$refs.container
        if (!dom || dom.scrollHeight === 0) {
          return false;
        }
        dom.scrollTop = dom.scrollHeight - dom.clientHeight
      }, 100)
    },
    // 选取发送照片
    sendImage({ files, id, type }) {
      let _that = this
      let blob = new Blob([files[0]]);
      let FileMessage = null
      let message = null
      if (type === 'image') {
        FileMessage = {
          progress: 0,
          from: _that.orderDetail.orderPatientID,
          type: 'TIMImageElem',
          src: window.URL.createObjectURL(blob),
          payload: {
            data: 'imageMessage'
          }
        }
        message = _that.tim.createImageMessage({
          to: this.orderDetail.doctorID,
          conversationType: TencentCloudChat.TYPES.CONV_C2C,
          payload: {
            file: files[0]
          },
          onProgress: function (event) {
            FileMessage.progress = event * 100
          }
        });
      } else if (type === 'video') {
        FileMessage = {
          progress: 0,
          from: _that.orderDetail.orderPatientID,
          type: 'TIMVideoFileElem',
          src: window.URL.createObjectURL(blob),
          payload: {
            data: 'videoMessage'
          }
        }
        message = _that.tim.createVideoMessage({
          to: this.orderDetail.doctorID,
          conversationType: TencentCloudChat.TYPES.CONV_C2C,
          payload: {
            file: files[0]
          },
          onProgress: function (event) {
            FileMessage.progress = event * 100
          }
        });
      }
      _that.messageList.push(FileMessage)
      _that.popupDialog = false
      _that.$nextTick(function () {
        _that.handleScrollBottom()
      })
      // 2. 发送消息
      let promise = _that.tim.sendMessage(message);
      promise.then(function (imResponse) {
        // 发送成功
      }).catch(function (imError) {
        // 发送失败
        console.warn('sendMessage error:', imError);
        showNotify({
          type: 'warning',
          message: '发送失败',
          duration: 1000
        });
      });
    },
    goBack() {
      // this.$router.back()
      const deviceType = this.deviceType || getUrlParams()['deviceType']
      showDialog({
        title: '退出提示',
        message: '您确定要离开对话吗？',
        confirmButtonText: '确定',
        confirmButtonColor: '#438BEF',
        showCancelButton: true,
        cancelButtonText: '取消',
        cancelButtonColor: '#438BEF',
        closeOnClickOverlay: true
      }).then(() => {
        if (deviceType === 'wechat') {
          wx.miniProgram.navigateBack({
            delta: history.length
          });
        } else if (deviceType === 'uniapp') {
          window.postMessage({
            data: {
              action: 'popstate'
            }
          }, '*')
          uni.postMessage({
            data: {
              action: 'popstate'
            }
          })
        } else {
          this.$router.back()
          try {
            window.Android.back();
          } catch (e) {

          }
        }
      })
    },
    getUrlParams() {
      if (this.$route.name === 'rpViewer') return
      let obj = getUrlParams()
      if (!obj['orderID'] || !obj['token']) {
        showDialog({
          message: '参数缺失，请重新进入',
          confirmButtonText: '确定',
          confirmButtonColor: '#438BEF',
          closeOnClickOverlay: true
        });
      }
      this['global/updateUrlParams'](obj)
    },
    ...mapMutations(['global/updateStep', 'global/updateDoctorInfo', 'user/updateOrderDetail', 'global/updateMask', 'global/updateUrlParams', 'user/updateUserInfo', 'global/updateVideoStart', 'global/updateDuration'])
  },
  unmounted() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/common.scss";

.consultation {
  // margin-top: 44px;
  // height: calc(100vh - 2rem);
}

.contentBody {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.seat {
  height: 15px;
  width: 100%;
}

.nav-head {
  height: 44px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;

  .back {
    margin-top: 8px;
    margin-left: 8px;

    img {
      width: 24px;
    }
  }

  .nav-title {
    font-size: 18px;
    display: flex;
    justify-content: center;
    width: calc(100% - 36px);
    padding-right: 32px;
  }
}

.contianer {
  height: calc(100vh - 44px - 52px);
  overflow: auto;
  // margin: 44px 0;
  position: absolute;
  width: 100%;
  z-index: 888;
  margin-top: 44px;
  // padding-bottom: 60px;
}

.mainContent {
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.nav-tips {
  background: #FEEFD0;
  padding: 10px 16px;
  font-size: 12px;
  text-align: center;
  color: #F6A70A;
  position: fixed;
  width: 100%;
}

.fix-bottom {
  height: 41px;
}

.message-item {
  margin-top: 16px;
}

.send {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
}

.image-more>img {
  height: 24px;
}

.image-more {
  padding: 14px 16px;
  position: relative;
}

.image-more>.upload-input-cover {
  opacity: 0;
  position: absolute;
  // height: 24px;
  // width: 24px;
  // top: 14px;
  // left: 16px;
  top: 0;
  left: 0;
}

.send-input {
  flex: 1;
}

.send-button-area {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 8px 12px;
}

.send-button {
  color: white;
  height: 36px;
  padding: 0 20px;
  line-height: 36px;
  text-align: center;
  border-radius: 20px;
  font-size: 14px;
  white-space: nowrap;
}

.blue-btn {
  background: var(--primary-color);
}

.grey-btn {
  background: #666666;
}

.send-input {
  border-radius: 20px;
  background: #f6f6f6;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 36px;
}

.send-input>input {
  background: none;
  height: 90%;
}

.more-message,
.no-more-message {
  color: #2887e8;
  font-size: 13px;
  padding: 15px 10px 0;
  text-align: center;
}

.waiting {
  background: #def3ea;
  color: #0a6f41;
  padding: 10px 16px;
  font-size: 14px;
  display: inherit;
  border-radius: 8px;
  margin-top: 24px;
  align-items: center;
}

.waiting>img {
  height: 24px;
  width: 24px;
}

.waiting-cover {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 接听视频
.video_main {
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #ffffff;
}

.network-video {
  width: 16px;
  height: 16px;
  margin: 5px 0;
  cursor: pointer;

  img {
    width: 100%;
  }
}

.network-tips {
  font-size: 14px;
  color: #c0c4cc;
}

.yfw-header-hang {
  width: 100%;
  color: #262626;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .hang-title {
    width: 50px;
    height: 50px;
    background-color: #ccd4dd;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
  }

  .hang-name {
    font-size: 15px;
    margin: 5px 0;
  }

  .hang-tips {
    font-size: 12px;
  }
}

.yfw-footer-hang {
  margin-top: 2%;
  display: flex;
  justify-content: space-around;
  width: 100%;

  .hang-wrap {
    gap: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;

    .call-end {
      font-size: 15px;
      margin: 5px 0;
    }
  }
}

.send-end {
  font-size: 15px;
  background-color: #ffffff;
  text-align: center;
  padding: 12px 0;
}

.end-button {
  z-index: 1000;
  font-size: 14px;
  color: #fff;
  border: none;
  background-color: var(--primary-color);
  padding: 5px 20px;
  margin: 18px 0;
  border-radius: 4px;
}

.end-inq {
  width: 100%;
  background: white;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
}

.close-inquiry {
  justify-content: center;
  display: flex;
  flex-direction: column;

  h3 {
    font-size: 14px;
  }

  span {
    font-size: 12px;
    color: #666;
  }
}

.video-component {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.imageView {
  width: 60px;
  height: 60px;
}

.labelText {
  font-size: 18px;
  color: white;
}

.waitText {
  font-size: 15px;
  color: white;
}

// 适配 1024x600 等小屏设备（机器人/嵌入式）
@media (max-height: 620px) {
  .nav-head {
    height: 30px;
  }
}

// @media (max-height: 810px) {

//   .video_main {
//     justify-content: center;
//     align-items: center;
//     display: flex;
//     flex-direction: column;
//     height: 100vh;
//     background-color: #ffffff;
//   }

//   .nav-head {
//     height: 22px;

//     .back {
//       margin-top: 3px;
//       margin-left: 3px;

//       img {
//         width: 15px;
//       }
//     }

//     .nav-title {
//       font-size: 12px;
//     }
//   }

//   .more-message,
//   .no-more-message {
//     font-size: 10px;
//     text-align: center;
//   }

//   .message-item {
//     margin-top: 5px;
//   }

//   .send {
//     padding: 4px 0;
//   }

//   .send-button-area {
//     padding: 4px 8px;
//   }

//   .send-button {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     height: 26px;
//     padding: 0 14px;
//     font-size: 11px;
//     line-height: 26px;
//   }

//   .yfw-header-hang {
//     width: 100%;
//     color: #262626;
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;

//     .hang-title {
//       width: 30px;
//       height: 30px;
//       display: flex;
//       font-size: 18px;

//       img {
//         width: 30px;
//         height: 30px;
//       }
//     }
//   }

//   .yfw-footer-hang {
//     margin-top: 2%;

//     .hang-wrap {
//       gap: 6px;
//       cursor: pointer;
//       display: flex;
//       flex-direction: column;
//       align-items: center;

//       .hang-icon {
//         width: 30px;
//         height: 30px;
//         margin: 8px 0;

//         img {
//           width: 100%;
//         }
//       }
//     }
//   }

//   .end-inq {
//     padding: 5px 5px;
//   }

//   .close-inquiry {
//     justify-content: center;
//     display: flex;
//     flex-direction: column;
//     padding-left: 10px;

//     h3 {
//       font-size: 12px;
//     }

//     span {
//       font-size: 10px;
//       color: #666;
//     }
//   }

//   .end-button {
//     font-size: 12px;
//     padding: 5px 10px;
//     margin: 5px 0;

//   }

//   .imageView {
//     width: 30px;
//     height: 30px;
//   }

//   .labelText {
//     font-size: 13px;
//     color: white;
//   }

//   .waitText {
//     margin-bottom: 5px;
//     font-size: 10px;
//     color: white;
//   }
// }

// @media (max-height: 610px) {
//   .nav-head {
//     position: fixed;
//     z-index: 999;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 30px;
//     line-height: 30px;
//     background: white;
//     display: flex;
//     align-items: center;

//     .back {
//       margin-top: 5px;
//       margin-left: 5px;

//       img {
//         width: 18px;
//       }
//     }

//     .nav-title {
//       font-size: 10px;
//       display: flex;

//       justify-content: center;
//       width: calc(100% - 36px);
//     }
//   }
// }</style>
<style lang="scss">
.tk-popover .tk-popover_trigger {
  font-size: 0;
  display: block !important;
}
</style>
